import { STATUS_COLORS } from '../constants/theme';
import { conditionalStatusStyle } from '../../services/utils';

export const normalizeStatus = (status) => {
  if (!status) return '';

  return status
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/nothired/g, 'notHired')
    .replace(/noresponse/g, 'noResponse')
    .replace(/needsreview/g, 'needsReview');
};

export const getStatusColor = (status) => {
  if (!status || status === '-') {
    return '#595959';
  }

  const normalizedStatus = normalizeStatus(status);
  const statusStyle = conditionalStatusStyle(normalizedStatus);

  return STATUS_COLORS[statusStyle.color] || '#4169e1';
};

export const resolveApplicationDate = (application, referralSubmissions = []) => {
  if (application?.atsApplicationDate) {
    return application.atsApplicationDate;
  }

  if (application?.legacyReferralId && referralSubmissions?.length) {
    const matchingSubmission = referralSubmissions.find(
      (submission) => String(submission.id) === String(application.legacyReferralId)
    );

    return matchingSubmission?.referralDate || null;
  }

  return null;
};

export const getDateHeader = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const isToday = date.toDateString() === today.toDateString();
  const isYesterday = date.toDateString() === yesterday.toDateString();

  const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
  const monthDay = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const year = date.getFullYear();

  if (isToday) {
    return `Today ${dayOfWeek} ${monthDay}, ${year}`;
  } else if (isYesterday) {
    return `Yesterday, ${dayOfWeek} ${monthDay}, ${year}`;
  } else {
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }
};

export const groupEventsByMonth = (timelineEvents) => {
  if (!timelineEvents) return [];

  const groups = [];
  let currentMonthYear = null;

  timelineEvents.forEach((event) => {
    const eventDate = new Date(event.date);
    const monthYear = `${eventDate.getMonth()}-${eventDate.getFullYear()}`;

    if (monthYear !== currentMonthYear) {
      currentMonthYear = monthYear;
      groups.push({
        type: 'header',
        date: event.date,
        id: `header-${monthYear}`
      });
    }

    groups.push(event);
  });

  return groups;
};
